import React from "react";

export default function MSAccess_Int() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Int</h1>
      <p>This is the MSAccess_Int component generated from the SQL JSON.</p>
    </div>
  );
}
